export const SocialMediaLinks = {
  FACEBOOK: 'https://www.facebook.com/people/Teknevia/100075736485964',
  INSTAGRAM: 'https://www.instagram.com/teknevia/',
  TWITTER: 'https://twitter.com/teknevia',
  LINKEDIN: 'https://www.linkedin.com/company/tekneviateknoloji/',
  YOUTUBE: 'https://www.youtube.com/@teknevia',
  TIKTOK: 'https://www.tiktok.com/@teknevia',
  PINTEREST: 'https://www.pinterest.com/teknevia/',
};
